import React, { PureComponent } from 'react';
import Loader from '../../../../components/Loader';
import Section from '../../../../components/Section';
import styles from './Shoutbox.scss';
import ShoutItem from './childcomponents/ShoutItem';

class Shoutbox extends PureComponent {
	render() {
		const { shouts, enabled, locale } = this.props;
		if (!shouts) {
			return <Loader label={locale['waiting.for.shouts']} />;
		}
		if (!enabled) {
			return <Loader label={locale['shouts.not.enabled']} />;
		}
		if (!shouts.length) {
			return <Loader label={locale['no.shouts']} />;
		}

		return (
			<Section>
				<Section.Heading>{locale.shouts}</Section.Heading>
				<div className={styles.root}>
					{shouts.map(item => (
						<ShoutItem key={item.id} shout={item} />
					))}
				</div>
			</Section>
		);
	}
}

Shoutbox.propTypes = {};

Shoutbox.defaultProps = {};

export default Shoutbox;



// WEBPACK FOOTER //
// ./src/ui/interaction/children/sections/shoutbox/Shoutbox.component.js